/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Chat Bot Event Object
 */
export type ChatBotEvent = {
    /**
     * Event Type (init/quit/back/respond)
     */
    type: string;
    /**
     * Timestamp
     */
    ts: number;
    /**
     * Arbitrary Client data
     */
    clientData: any;
    responses: Array<string>;
    actionContext?: string;
    /**
     * Clone flag to trigger cloning
     */
    cloneFlag?: boolean;
    /**
     * Clone source type
     */
    cloneSource?: ChatBotEvent.cloneSource;
    /**
     * Source ID for cloning
     */
    cloneId?: number;
}

export namespace ChatBotEvent {

    /**
     * Clone source type
     */
    export enum cloneSource {
        QUERY = 'query',
        DRAFT = 'draft',
    }


}
